import Media from './../mediaDetect.js'; //Детектор медиа
import TypicalSlider from './typical-slider.js';

var arrScrollTab = [];

let Tabs = {
    init: function(tabs){
        // Получаем все табы на странице и для каждого добавляем скролл
        tabs.each(function(index, value){
            let _this = $(this);

            if(!_this.hasClass('init') && !_this.data('no-scroll-tabs')){

                let $tabsNav = _this.find('.tabs__nav'),
                    myScrollTab;

                _this.addClass('init');

                if (!($tabsNav.find('.scroll-content').length) ){
                    // Добавляем внутреннюю обертку скроллящейся части
                    $tabsNav.wrapInner('<div class="scroll-content"></div>');
                    // Добавляем стрелки вперёд-назад
                    $tabsNav.append('<div class="scroll-left"></div><div class="scroll-right"></div>');

                    $tabsNav.find('.scroll-content').css('min-width', Tabs.minWidthTabs($tabsNav) + 'px');
                }
                    
                $tabsNav.addClass('tabs__nav_' + index).attr('data-index-nav-tabs', index);

                Tabs.initScrollContent('.tabs__nav_' + index, myScrollTab, tabs);
            }

            if(!_this.hasClass('init') && _this.data('mobile-slider-tabs')){
                Tabs.initListMobileSliderTabs(tabs.find('.tabs__content'), tabs.find('[data-item-nav-tabs]'));
            }
        });
    },
    reinitTypicalSlidersCurrentTab: function(){
        var typicalSliders = $('[data-pane-tabs].active').find('[data-typical-slider]');

        if(typicalSliders.length){
            typicalSliders.each(function(index) {
                let _this = $(this);

                _this.slick('unslick');
                TypicalSlider.init(_this);
                _this.find('[data-curr-item-counter-typical-slider]').text('01');
            });
        }
    },
    // плагин iScroll
    setArrow: function(myScrollTab, left, right){
        if (myScrollTab.x == 0) {
            left.hide();
        } else if (myScrollTab.x < 0) {
            left.show();
        }
        if (myScrollTab.x == myScrollTab.maxScrollX) {
            right.hide();
        } else if (myScrollTab.x > myScrollTab.maxScrollX) {
            right.show();
        }
    },
    updateScrollContent: function(myScrollTab) {
        setTimeout(function () {
            var $wrapper = $(myScrollTab.wrapper),
                $left = $wrapper.find('.scroll-left'),
                $right = $wrapper.find('.scroll-right'),
                $tabContent = $wrapper.find('.scroll-content');

            $tabContent.css('min-width', Tabs.minWidthTabs($wrapper) + 'px');

            myScrollTab.refresh();
            Tabs.setArrow(myScrollTab, $left, $right);
        }, 0);
    },
    initScrollContent: function(elem, myScrollTab, tabs) {
        myScrollTab = new IScroll(elem, {
            eventPassthrough: true,
            scrollX: true,
            scrollY: false,
            preventDefault: false,
            scrollbars: 'custom'
        });

        arrScrollTab[tabs.find('[data-index-nav-tabs]').data('index-nav-tabs')] = myScrollTab;

        if(!tabs.hasClass('no-slide-pane')) {
            Tabs.initListMobileSliderTabs(tabs.find('.tabs__content'), tabs.find('[data-item-nav-tabs]'), myScrollTab);
        }

        var $elem = $(elem),
            $scroller = $elem.find('.scroll-content'),
            $left = $elem.find('.scroll-left'),
            $right = $elem.find('.scroll-right');

        Tabs.setArrow(myScrollTab, $left, $right);

        $('.main').on('click', elem + ' .scroll-left', function(){
            var step_scroll = (Math.abs(myScrollTab.maxScrollX)/2 < 100 ? Math.abs(myScrollTab.maxScrollX) : Math.abs(myScrollTab.maxScrollX)/2 + 10),
                x = (Math.abs(myScrollTab.x) > step_scroll ? step_scroll : Math.abs(myScrollTab.x));

            myScrollTab.scrollBy(x, 0, parseInt(x/10));
        });

        $('.main').on('click', elem + ' .scroll-right', function(){
            var step_scroll = (Math.abs(myScrollTab.maxScrollX)/2 < 100 ? Math.abs(myScrollTab.maxScrollX) : Math.abs(myScrollTab.maxScrollX)/2 + 10),
                x_max = Math.abs(myScrollTab.maxScrollX) - Math.abs(myScrollTab.x),
                x = (x_max < step_scroll ? x_max : step_scroll);

            myScrollTab.scrollBy(-1*x, 0, parseInt(x/10));
        });

        myScrollTab.on('scrollEnd', function() {
            Tabs.setArrow(this, $left, $right);
        });

        $(window).on('resize', function(){
            Tabs.updateScrollContent(myScrollTab);
        });
    },
    minWidthTabs: function(tabsNav){
        // Определяем минимальную ширину текущей навигации таба
        var minWidth = 0;
        tabsNav.find('[data-item-nav-tabs]').each(function(index, value){
            minWidth += $(this).outerWidth(true);
        });

        return minWidth;
    },
    switchTab: function(_this){
        if(!_this.hasClass('active')) {
            let container = _this.closest('[data-tabs]'),
                value = _this.data('item-nav-tabs');

            container.find('[data-pane-tabs]').removeClass('active');
            container.find('[data-item-nav-tabs]').removeClass('active');

            _this.addClass('active');
            container.find('[data-pane-tabs="' + value + '"]').addClass('active');

            if(!container.data('no-scroll-tabs')) {
                Tabs.reinitTypicalSlidersCurrentTab();
            }
        }
    },
    initListMobileSliderTabs: function(slider, itemsNavTabs, myScrollTab){
        let sliderMobileConfig = {
            infinite: false,
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoplay: false,
            speed: 600,
            fade: false,
            arrows: false,
            dots: false
        }

        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            itemsNavTabs.removeClass('active');
            itemsNavTabs.eq(nextSlide).addClass('active');

            if(myScrollTab) {
                myScrollTab.scrollToElement('[data-item-nav-tabs].active', 600, -30, null);
                Tabs.updateScrollContent(myScrollTab);
            } 
        });

        if(Media.detect().isMobile){
            slider.slick(sliderMobileConfig);
        }

        // обрабатываем изменение точки остановки
        $(window).on('mdbreakpoint', function(e, breakpointOld, breakpointOldNew) {
            if((breakpointOld == 'isMobile')&&
                (breakpointOldNew == 'isTablet' || breakpointOldNew == 'isDesktop' || breakpointOldNew == 'isDesktopHD')) {

                var initRoutesSlider = slider.hasClass('slick-slider');
                if(initRoutesSlider){
                    slider.slick('unslick');
                    Tabs.reinitTypicalSlidersCurrentTab();
                }
            }

            if((breakpointOld == 'isTablet' || breakpointOld == 'isDesktop' || breakpointOld == 'isDesktopHD')
                && (breakpointOldNew == 'isMobile')) {

                var initRoutesSlider = slider.hasClass('slick-slider');
                if(!initRoutesSlider) slider.slick(sliderMobileConfig);
            }
        });

        itemsNavTabs.on('click', function(){
            if(Media.detect().isMobile){
                var valueCurrTab = $(this).data('item-nav-tabs'),
                    indexSlide = slider.find('[data-pane-tabs="' + valueCurrTab + '"]').closest('[data-slick-index]').data('slick-index');

                slider.slick('slickGoTo', indexSlide);
            }
        });
    },
    updateTabs: function(currTabs){
        let navTabs = currTabs.find('[data-index-nav-tabs]'),
            contentTabs = currTabs.find('.tabs__content');

        if(navTabs.length && !currTabs.data('no-scroll-tabs')) {
            contentTabs.slick('unslick');
            Tabs.initListMobileSliderTabs(contentTabs, currTabs.find('[data-item-nav-tabs]'), arrScrollTab[navTabs.data('index-nav-tabs')]);
        }
    }
}

$(document).ready(function ($) {
    // Если передан хэш - устанавливаем указанный таб
    let hash = window.location.hash.substring(1);
    if (hash != '' && $('[data-item-nav-tabs="' + hash + '"]').length) {
        Tabs.switchTab($('[data-item-nav-tabs="' + hash + '"]'));
    }

    // Переключение табов
    $('.main').on('click', '[data-item-nav-tabs]', function(){
        Tabs.switchTab($(this));
    });

    let tabsItem = $('[data-tabs]');
    if(tabsItem.length) {
        Tabs.init(tabsItem);
    }
});

export default {
  init: Tabs.init,
  updateTabs: Tabs.updateTabs
};


// WEBPACK FOOTER //
// ./components/tabs.js